/* global $ */
import React, { forwardRef, useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { TriangleAlert } from "lucide-react";
import "../pages/configure/global-constants/PredefineGlobalConstant.css";
import "./ErrorModel.css";

// Dimmed backdrop. Clicking it does not close the popup (same as before);
// only the Ok button or Escape closes it.
const ErrorBackdrop = forwardRef(({ open }, ref) => (
  <Backdrop ref={ref} open={open} className="em-backdrop" />
));

// The shared confirmation dialog (ConfirmationBox, a Bootstrap modal)
const CONFIRM_MODAL_SELECTOR = "#ConfirmModel";
// Safety net in case Bootstrap never fires "hidden" (e.g. mid-animation)
const CONFIRM_HIDE_FALLBACK_MS = 600;

const ErrorModel = (props) => {
  // Only show once any open confirmation dialog has finished closing,
  // so the error never appears behind / on top of "Are you sure?".
  const [readyToShow, setReadyToShow] = useState(false);

  useEffect(() => {
    if (!props.ErrorModel) {
      setReadyToShow(false);
      return undefined;
    }

    const $confirm = typeof $ === "function" ? $(CONFIRM_MODAL_SELECTOR) : null;

    if (!$confirm || !$confirm.length || !$confirm.hasClass("show")) {
      setReadyToShow(true);
      return undefined;
    }

    let done = false;
    const show = () => {
      if (done) return;
      done = true;
      setReadyToShow(true);
    };

    $confirm.one("hidden.bs.modal", show);
    $confirm.modal("hide");
    const fallback = setTimeout(show, CONFIRM_HIDE_FALLBACK_MS);

    return () => {
      done = true;
      clearTimeout(fallback);
      $confirm.off("hidden.bs.modal", show);
    };
  }, [props.ErrorModel]);

  const message =
    props.ErrorMessage === ""
      ? props?.emailError || "Something Went Wrong"
      : props.ErrorMessage;

  return (
    <Modal
      open={Boolean(props.ErrorModel) && readyToShow}
      onClose={props.handleClose}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-message"
      BackdropComponent={ErrorBackdrop}
      className="em-modal"
    >
      <div className="em-dialog" role="alertdialog" tabIndex={-1}>
        <div className="em-card">
          <div className="em-icon-halo" aria-hidden="true">
            <div className="em-icon">
              <TriangleAlert size={30} strokeWidth={2} />
            </div>
          </div>

          <h4 className="em-title" id="error-modal-title">
            {props.errorMessageTitle || "Unable to complete this action"}
          </h4>

          <p className="em-message" id="error-modal-message">
            {message}
          </p>

          <div className="em-footer">
            <button
              type="button"
              className="em-btn"
              autoFocus
              onClick={() => {
                props.handleClose();
              }}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModel;
